module.exports = __webpack_public_path__ + "static/ielts-academic-ccabfdfac6689160488164e067f81bdc.png";